export default __webpack_public_path__ + "static/media/contact-us.2df677e5.svg";